import { useSuspenseQuery } from '@tanstack/react-query';
import { configService } from 'shared/src/api/configService';
import { queryKey } from '../../../constants/queryKey';

export const useConfigs = () => {
  return useSuspenseQuery({
    queryKey: queryKey.configs(),
    queryFn: configService.getConfigs,
  });
};
